import { Button, Modal } from "react-bootstrap";
import { StoreCouponModel } from "../../../models";
import { BiSolidOffer } from "react-icons/bi";
import { sanitizeHtml } from "../../../helpers";

type Props = {
  show: boolean;
  coupon: StoreCouponModel;
  handleClose: () => void;
};

const CouponDetailModal: React.FC<Props> = ({ show, coupon, handleClose }) => {
  return (
    <Modal
      className="cart_aad_on order_option_popup"
      show={show}
      onHide={handleClose}
      centered
    >
      <Modal.Header className="pb-0 pt-0" closeButton>
        <h2>{!coupon.is_auto ? coupon.code : ""}</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-1">
          <BiSolidOffer size={36} className="brand-primary" />
        </div>
        <p className="text-center fw-bold fs-4 mb-1">{coupon.title}</p>
        <p
          className="text-center text-muted mx-3"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(coupon.description) }}
        />
        {/* <p className="text-muted fw-bold d-flex align-items-center justify-content-center gap-1"><BiCalendar size={24} /> Valid till {coupon.expire_at}</p> */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleClose}>
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CouponDetailModal;
